import Swiper from 'swiper';
import { HeaderTracking } from './header-tracking';
import { getUserCartInfos } from './header-service';
import { renderHeader } from './templates/user-header-template';
import { page } from '../../PageInit/Scripts/globals';


export class Header {
    private swiperHeaderNavigation: Swiper;
    constructor() {
        this.swiperHeaderNavigation = new Swiper(".swiper-header-navigation", {
            modules: [],
            slidesPerView: "auto",
            on: {
                init: this.headerPositionBehavior.bind(this),
                resize: this.headerPositionBehavior.bind(this)
            }
        });

        new HeaderTracking().setTrackUniverseHeaderClick();

        const userHeaderEl = document.querySelector<HTMLElement>('.js-user-header');
        const isUserConnected = Boolean(page.isConnected);

        if (userHeaderEl) {
            const searchbarHighlightFlagStr = userHeaderEl.dataset.searchbarHighlightFlag;
            const searchbarHighlightFlag = searchbarHighlightFlagStr === 'true'; 

            renderHeader(userHeaderEl, { isLoggedIn: isUserConnected, searchbarHighlightFlag: searchbarHighlightFlag });

            if (isUserConnected) {
                getUserCartInfos().then(updateCartQuantityIcon);
            }
        }
    }

    public headerPositionBehavior(swiper: Swiper) {
        const totalWidth = swiper.slides.length * swiper.slides[0].offsetWidth;
        const containerWidth = swiper.width;

        if (totalWidth <= containerWidth) {
            swiper.el.classList.add('no-swiping');
        } else {
            swiper.el.classList.remove('no-swiping');
        }
    }
}



export function updateCartQuantityIcon(q: number) {
    var cartQuantityIcon = document.querySelector('#js-CartQuantityIcon');
    if (cartQuantityIcon) {
        if (q <= 0) {
            cartQuantityIcon.classList.remove("header-notification");
        } else {
            cartQuantityIcon.classList.add("header-notification");
            cartQuantityIcon.innerHTML = q.toString();
        }
    }
}